export default __webpack_public_path__ + "static/media/list-modal.00ab844b.png";